/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import {
  Modal,
  Form,
} from 'semantic-ui-react';
//import { observer, inject } from 'mobx-react';
//import cx from 'classnames';
import $ from 'jquery';
import { convertPropertiesToCamelCase } from '../../utils/shared';
import closeBtn from '../../images/common/close-btn.svg';
import Loader from '../Loader/Loader';
//import WithRouter from '../Extensions/WithRouter';

class ExportModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: props.rowData || {},
      isOpenMED: props.isOpenMED,
      exportType: 'report',
      exportFormat: 'excel',
      toExport: 'local'
    };
    this.onCloseHandler = this.onCloseHandler.bind(this);
    this.onExport = this.onExport.bind(this);
    this.handletoExport = this.handletoExport.bind(this);
  }

  componentDidMount() {
    $(document).on('mouseover', '.popup_content .popup_content_item .text_area', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps) {
    const { isOpenMED, rowData } = this.props;
    if (prevProps.isOpenMED !== isOpenMED) {
      this.setState({
        isOpenMED,
        rowData,
      });
    }
  }

  handletoExport(e, { value }) {
    this.setState({
      toExport: value,
    });
  }

  onCloseHandler(e) {
    const { onClose } = this.props;
    if (e.target.classList[0] === 'right_button') {
      return null;
    }
    onClose();
  }

  onExport() {
    const { exportFormat, exportType, toExport } = this.state;
    const { handleModal } = this.props;
    handleModal(exportFormat, exportType, toExport);
  }

  setPrecisionLevel(object) {
    const data = convertPropertiesToCamelCase(object);
    if (typeof data.isUsePrecision !== 'undefined') {
      return data.isUsePrecision ? this.convertString(data.precisionLevel) : 'N/A';
    }
    return data.isShowPrecisionLevelMenu ? this.convertString(data.currentPrecisionLevel) : 'N/A';
  }

  convertString(string) {
    if (string === 'broad') {
      return 'Low';
    } if (string === 'medium') {
      return 'Medium';
    } if (string === 'narrow') {
      return 'High';
    } if (string === 'custom') {
      return 'Custom';
    }
  }

  render() {
    const { isDownloading, translate } = this.props;
    const { isOpenMED, rowData, toExport } = this.state;

    const options = [
      { key: 'local', text: 'Local File System', value: 'local' },
      { key: 's3', text: 'S3', value: 's3' },
      { key: 'email', text: 'Email', value: 'email' },
    ];

    const getModalContent = () => {
      if (isDownloading) {
        return (
          <div className="modal_popup_wrap export_data_wrap">
            <div className="modal_popup_box export_data_box">
              <div className="modal_popup export_data">
                <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                  <Loader
                    style={{
                      position: 'relative',
                      width: '80%',
                      height: '80%',
                      marginBottom: '15%',
                    }}
                  />
                  <span
                    style={{
                      fontWeight: '500',
                      fontSize: '16px',
                      marginTop: '35%',
                      display: 'inline-block',
                    }}
                  >
                    {translate('modal.message.prepare_report_download')}
                  </span>
                </div>
              </div>
            </div>
          </div>
        );
      }

      return (
        <div className="modal_popup_wrap export_data_wrap">
          <div className="modal_popup_box export_data_box">
            <div className="modal_popup export_data">
              <h2 className="title">
                {translate('modal.title.export_data')}
                <a
                  className="close_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.onCloseHandler}
                  onKeyUp={this.onCloseHandler}
                >
                  <img src={closeBtn} alt="" />
                </a>
              </h2>
              <div className="popup_content">
                <Form>
                  <Form.Group widths="equal">
                    <Form.Input
                      fluid
                      label={translate('modal.title.selected_file')}
                      value={rowData.name || rowData.uploadName || null}
                      readOnly
                    />
                    <Form.Field>
                      <label>{translate('modal.title.file_export_to')}</label>
                      <Form.Dropdown
                        options={options}
                        selection
                        defaultValue={toExport}
                        onChange={this.handletoExport}
                      />
                    </Form.Field>
                  </Form.Group>
                  <Form.Group widths="equal">
                    <Form.Input
                      fluid
                      label={translate('modal.title.file_format')}
                      value={translate('modal.title.excel')}
                      readOnly
                    />
                    <Form.Input
                      fluid
                      label={translate('modal.title.precision_level')}
                      value={this.setPrecisionLevel(rowData)}
                      readOnly
                    />
                  </Form.Group>
                </Form>
              </div>
              <div className="button_wrap">
                <a
                  className="left_button"
                  onClick={this.onCloseHandler}
                  onKeyUp={this.onCloseHandler}
                >
                  {translate('modal.button.cancel')}
                </a>
                <a
                  className="right_button"
                  onClick={this.onExport}
                  onKeyUp={this.onExport}
                >
                  {translate('modal.button.export')}
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    };
    return (
      <Modal open={isOpenMED} onClose={this.onCloseHandler}>
        {getModalContent()}
      </Modal>
    );
  }
}

export default ExportModal;
